<template>
  <div class="multiple-choice-setting">
    <div class="mb-2 fz-14">
      <span>选项设置</span>
    </div>
    <div class="verification-label">验证选项</div>
    <div class="card-box">
      <div class="flex items-center">
        <span class='mr-1' style="flex:1">用户未选择</span>
        <!-- <el-checkbox-group v-model="correctAnswer" @change="onUpdate">
          <div v-for="item in items" :key="item.value" class="mb-1">
            <el-checkbox :label="item.value">
              <span>{{ item.label }}</span>
            </el-checkbox>
          </div>
        </el-checkbox-group> -->
        <el-select style="width:160px" v-model="correctAnswer" @change="onUpdate">
          <el-option
            v-for="item in items"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div class="flex-label">时,该答卷将被甄别</div>

    </div>
  </div>
</template>

<script>
import { questionType } from '@dygc/question'
export default {
  name: 'NPSScale',
  type: questionType.NPS_SCALE,
  data(){
    return {
      correctAnswerCursom:[]
    }
  },
  computed: {
    items() {
      return this.issue.labels.map((i,idx,arr) => {
        return {
          value: i.id,
          label: idx===0 || idx===arr.length -1 ? `${i.text}-${i.num}`: i.num
        }
      })
    },
    correctAnswer: {
      get() {
        return this.issue.correct_answer[0]
      },
      set(val) {
        this.issue.correct_answer = [val]
      }
    }
  },
}
</script>
<style lang="scss" scoped>
.multiple-choice-setting{
  .fz-14{
    font-size: 14px;
    color: rgba(0,0,0,0.85);
    font-weight: 600;
  }
  .verification-label{
    margin-top: 12px;
    font-size: 12px;
    color: rgba(0,0,0,0.85);
    line-height: 22px;
  }
  .flex{
    font-size: 12px;
    color: rgba(0,0,0,0.65);
  }
  .flex-label{
    line-height: 32px;
    color:rgba(0,0,0,0.65);
  }
}
</style>
